import * as React from 'react'
import { useQuery } from '@apollo/react-hooks'
import { find } from 'lodash'
import Link from 'next/link'

import { orderStatusesQuery } from '~/gql/queries'
import { useModalManager } from '~/hooks'
import type { ModalManagerProps } from '~/hooks/use-modal-manager'
import NewButton from '~/truck/new-button/NewButton'
import { notifySentry } from '~/utils'
import { images } from '~/utils/constants'

import { DialogHeader } from '../dialog/header'
import { DialogModal } from '../dialog/modal'
import OrderStatus from '../order-status'

interface Props extends ModalManagerProps {
  orderStatus: string
  orderId: string
  onClose: (withError?: boolean) => void
}

const OrderToReviewModal = (props: Props) => {
  const { orderStatus, orderId, onClose, modalId } = props

  const { closeModal } = useModalManager()

  const handleClose = () => {
    onClose()

    closeModal(modalId)
  }

  const { data, loading, error } = useQuery(orderStatusesQuery)

  if (loading) {
    return null
  }

  if (error || !data?.vendor?.orderStatuses) {
    console.error('Error al cargar los estados de pedido:', error)

    handleClose()

    return null
  }

  const orderToReviewStatus = find(data.vendor.orderStatuses, status => status.slug === orderStatus)

  if (!orderToReviewStatus) {
    console.error('No se encontró el estado de pedido:', orderStatus)

    notifySentry(error)

    handleClose()

    return null
  }

  return (
    <DialogModal
      onClose={handleClose}
      className="max-w-[450px] rounded-sm bg-white shadow-[0px_16px_24px_rgba(0,0,0,0.14),0px_6px_30px_rgba(0,0,0,0.12),0px_8px_10px_rgba(0,0,0,0.2)]"
    >
      <DialogHeader closable onClose={handleClose} closeIconSize="md" closeIconColor="black30" />
      <div className="flex flex-col items-center gap-3 pb-3">
        <img alt="icon" src={images.ILLUSTRATION_RATING} className="h-20" />
        <h4 className="text-lg font-bold">Califica tus pedidos</h4>
        <p className="text-center text-zinc-400">
          Tu último pedido en estado <OrderStatus name={orderToReviewStatus.name} color={orderToReviewStatus.color} />{' '}
          espera tu calificación.
        </p>
        <NewButton asChild onClick={handleClose} className="mx-auto w-fit">
          <Link href={`/mi-cuenta/pedidos/${orderId}`}>Ver pedido</Link>
        </NewButton>
      </div>
    </DialogModal>
  )
}

export default OrderToReviewModal
